/* ============================================================
   LIMITLESS FOG — custom.js
   Adds: animated ticker, scroll reveals, gold cursor glow
   Paste full contents into: assets/custom.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Wait for DOM ── */
  document.addEventListener('DOMContentLoaded', function () {
    initDeferredSizeGuideVideo();
    initFirstOrderOffer();
    initScrollReveal();
    initHeroParallax();
    initSectionLabels();

    function initDeferredSizeGuideVideo() {
      wirePageSizeGuideVideoLinks();
      bindSizeGuideVideoDelegation();

      var triggers = document.querySelectorAll('.lf-size-video-guide__trigger[popovertarget]');

      triggers.forEach(function (trigger) {
        var popover = document.getElementById(trigger.getAttribute('popovertarget'));
        var video = popover && popover.querySelector('.lf-size-video-guide__video[data-src]');

        if (!video) return;

        var loadVideo = function () {
          if (!video.getAttribute('src')) {
            video.setAttribute('src', video.getAttribute('data-src'));
            video.load();
          }
        };

        var loadAndPlayVideo = function () {
          loadVideo();

          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        };

        trigger.addEventListener('click', function (event) {
          if (trigger.tagName && trigger.tagName.toLowerCase() === 'a') {
            event.preventDefault();

            if (typeof popover.showPopover === 'function') {
              popover.showPopover();
            }
          }

          window.requestAnimationFrame(loadAndPlayVideo);
        });

        popover.addEventListener('toggle', function (event) {
          if (event.newState === 'open') loadAndPlayVideo();
        });
      });
    }

    function wirePageSizeGuideVideoLinks() {
      var pagePopover =
        document.getElementById('lf-size-video-guide-popover') ||
        document.getElementById('lf-page-size-video-guide-popover');

      if (!pagePopover) return;

      var candidates = document.querySelectorAll('a, button');

      candidates.forEach(function (candidate) {
        if (candidate.closest('.lf-size-video-guide__popover')) return;

        var text = (candidate.textContent || '').trim().toLowerCase();
        var href = candidate.getAttribute('href') || '';
        var pointsToSizeVideo =
          text.indexOf('video size guide') !== -1 ||
          text.indexOf('watch video size guide') !== -1 ||
          href.indexOf('VideoSG.mp4') !== -1 ||
          href.indexOf('#video-size-guide') !== -1;

        if (!pointsToSizeVideo) return;

        candidate.classList.add('lf-size-video-guide__trigger');
        candidate.setAttribute('popovertarget', 'lf-size-video-guide-popover');
        candidate.setAttribute('popovertargetaction', 'show');

        if (candidate.tagName.toLowerCase() === 'button' && !candidate.getAttribute('type')) {
          candidate.setAttribute('type', 'button');
        }
      });
    }

    function bindSizeGuideVideoDelegation() {
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('a, button, [role="button"]');

        if (!trigger || trigger.closest('.lf-size-video-guide__popover')) return;

        var popoverId = trigger.getAttribute('popovertarget');
        var shouldUsePagePopover = isPageSizeVideoLink(trigger);

        if (!popoverId && shouldUsePagePopover) {
          popoverId = 'lf-size-video-guide-popover';
        }

        if (!popoverId || (popoverId.indexOf('size-video-guide') === -1 && !shouldUsePagePopover)) return;

        var popover = document.getElementById(popoverId);

        if (!popover && shouldUsePagePopover) {
          popover =
            document.getElementById('lf-size-video-guide-popover') ||
            document.getElementById('lf-page-size-video-guide-popover');
        }

        if (!popover) return;

        event.preventDefault();
        openSizeGuideVideoPopover(popover);
      });
    }

    function isPageSizeVideoLink(element) {
      var text = (element.textContent || '').trim().toLowerCase();
      var href = element.getAttribute('href') || '';

      return (
        text.indexOf('video size guide') !== -1 ||
        text.indexOf('watch video size guide') !== -1 ||
        text.indexOf('video sizing guide') !== -1 ||
        href.indexOf('VideoSG.mp4') !== -1 ||
        href.indexOf('videosg.mp4') !== -1 ||
        href.indexOf('#video-size-guide') !== -1 ||
        href.indexOf('#size-video-guide') !== -1
      );
    }

    function openSizeGuideVideoPopover(popover) {
      var video = popover.querySelector('.lf-size-video-guide__video[data-src]');

      if (video && !video.getAttribute('src')) {
        video.setAttribute('src', video.getAttribute('data-src'));
        video.load();
      }

      if (typeof popover.showPopover === 'function' && !popover.matches(':popover-open')) {
        try {
          popover.showPopover();
        } catch (error) {}
      }

      if (!video) return;

      window.requestAnimationFrame(function () {
        var playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    }

    function initFirstOrderOffer() {
      suppressShopifyFormsTeaser();

      var dialog = document.getElementById('lf-first-order-dialog');

      if (!dialog) return;

      document.addEventListener('click', function (event) {
        var offer = event.target.closest('[data-lf-open-first-order-dialog]');
        var closeButton = event.target.closest('[data-lf-close-first-order-dialog]');
        var copyButton = event.target.closest('[data-lf-copy-discount-code]');

        if (copyButton) {
          copyDiscountCode(copyButton);
          return;
        }

        if (closeButton) {
          dialog.close();
          return;
        }

        if (!offer) return;

        event.preventDefault();

        if (!dialog.open) dialog.showModal();
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });

      var successMessage = dialog.querySelector('[data-lf-first-order-success]');

      if (successMessage && !dialog.open) {
        dialog.showModal();
        successMessage.focus();
      }
    }

    function copyDiscountCode(button) {
      var code = button.getAttribute('data-lf-copy-discount-code');

      if (!code || !navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') return;

      navigator.clipboard.writeText(code).then(function () {
        button.textContent = 'Copied';
        window.setTimeout(function () {
          button.textContent = 'Copy';
        }, 1800);
      }).catch(function () {});
    }

    function suppressShopifyFormsTeaser() {
      function hideTeaser(root) {
        var teaser = root.querySelector('[data-testid="form-teaser"]');

        if (!teaser) return;

        teaser.hidden = true;
        teaser.setAttribute('aria-hidden', 'true');
        teaser.style.setProperty('display', 'none', 'important');
      }

      function watchHost(host) {
        if (!host.shadowRoot || host.dataset.lfTeaserSuppressed === 'true') return;

        host.dataset.lfTeaserSuppressed = 'true';
        hideTeaser(host.shadowRoot);

        new MutationObserver(function () {
          hideTeaser(host.shadowRoot);
        }).observe(host.shadowRoot, { childList: true, subtree: true });
      }

      function watchExistingHosts() {
        document.querySelectorAll('shopify-forms-embed').forEach(watchHost);
      }

      watchExistingHosts();

      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('shopify-forms-embed').then(watchExistingHosts);
      }

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;

            if (node.matches('shopify-forms-embed')) watchHost(node);
            node.querySelectorAll('shopify-forms-embed').forEach(watchHost);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  });


  /* ─────────────────────────────────────────────
     2. SCROLL REVEAL
     Adds fog-reveal class to key elements then
     triggers is-visible when they enter viewport
  ───────────────────────────────────────────── */
  function initScrollReveal() {
    var targets = [
      '.card-wrapper',
      '.card',
      '.collection-card-wrapper',
      '.banner__content > *',
      '.image-with-text__content > *',
      '.rich-text__wrapper > *',
      '.newsletter .section-header',
      '.section-header__title',
      '.section-header',
      '.image-with-text__media-item',
    ];

    var elements = document.querySelectorAll(targets.join(', '));

    elements.forEach(function (el, i) {
      el.classList.add('fog-reveal');
      /* Stagger delay for grid children */
      var delay = (i % 4) + 1;
      if (delay > 1) el.classList.add('fog-reveal-delay-' + delay);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.fog-reveal').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      /* Fallback for older browsers */
      document.querySelectorAll('.fog-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }


  /* ─────────────────────────────────────────────
     3. HERO PARALLAX
     Subtle upward drift on the banner background
     as the user scrolls — matches mockup feel
  ───────────────────────────────────────────── */
  function initHeroParallax() {
    var bannerMedia = document.querySelector('.banner__media, .hero__media');
    if (!bannerMedia) return;

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          if (scrollY < window.innerHeight) {
            bannerMedia.style.transform = 'translateY(' + (scrollY * 0.28) + 'px)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }


  /* ─────────────────────────────────────────────
     4. AUTO SECTION EYEBROW LABELS
     Scans for section headings and prepends
     the gold label decoration automatically
  ───────────────────────────────────────────── */
  function initSectionLabels() {
    /* Map section index → label text */
    var labels = {
      1: 'Featured Collection',
      2: 'Browse Collections',
      3: 'Character Series',
      4: 'Top Picks',
      5: 'Handcrafted',
      6: 'The Brand',
    };

    var sections = document.querySelectorAll('main .shopify-section');

    sections.forEach(function (section, i) {
      if (!labels[i]) return;

      var heading = section.querySelector('h2, .section-header__title, .collection__title');
      if (!heading) return;

      /* Don't double-inject */
      if (section.querySelector('.fog-eyebrow')) return;

      var eyebrow = document.createElement('p');
      eyebrow.className = 'fog-eyebrow';
      eyebrow.textContent = labels[i];
      eyebrow.style.cssText = [
        'font-family: Oswald, sans-serif',
        'font-size: 10px',
        'font-weight: 700',
        'letter-spacing: 0.32em',
        'text-transform: uppercase',
        'color: #C9A96E',
        'margin-bottom: 8px',
        'display: flex',
        'align-items: center',
        'gap: 12px',
      ].join(';');

      /* Gold dash before label */
      var dash = document.createElement('span');
      dash.style.cssText = 'display:block;width:24px;height:1px;background:#8B6914;flex-shrink:0';
      eyebrow.prepend(dash);

      heading.parentNode.insertBefore(eyebrow, heading);
    });
  }


  /* ─────────────────────────────────────────────
     5. HEADER — add transparent → solid on scroll
  ───────────────────────────────────────────── */
  (function initStickyHeader() {
    var header = document.querySelector('.header, .site-header');
    if (!header) return;

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 60) {
        header.style.background = 'rgba(13,13,13,0.98)';
        header.style.boxShadow  = '0 2px 40px rgba(0,0,0,0.7)';
      } else {
        header.style.background = 'rgba(13,13,13,0.92)';
        header.style.boxShadow  = 'none';
      }
    }, { passive: true });
  })();

})();
